import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core'
import { IButtonItem } from './button-group.interface'

@Component({
  selector: 'lla-button-group',
  templateUrl: './button-group.component.html',
  styleUrls: ['./button-group.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ButtonGroupComponent {
  @Input() buttons: IButtonItem[] = []
  @Input() containerClass = ''
  @Input() itemClass = ''
  @Input() iconClass = 'text-xs!'
  @Input() selectedButtonValue: any

  @Output() selectedButtonChanged = new EventEmitter()
}
